import { createSelector } from '@reduxjs/toolkit';
import { riskAssessmentsNotDeleted } from 'src/store/selectors';

export const emergencyMeasuresCardsPublished = createSelector(
  riskAssessmentsNotDeleted,
  function (riskAssessments): boolean {
    return (
      riskAssessments.find((r) => {
        return r.measuresCardPublished;
      }) !== undefined
    );
  },
);
